export default "__VITE_ASSET__CQBa84Ej__"